import { atom } from 'recoil';

export interface ChatbotState {
  isOpen: boolean;
  initialMessage?: string;
}

export const chatbotState = atom<ChatbotState>({
  key: 'chatbotState',
  default: {
    isOpen: false,
    initialMessage: undefined,
  },
});
